import React, { useEffect } from 'react';
//infinity-observer
import { useInView } from 'react-intersection-observer';
//hook
import useReservHook from 'src/webapp/hooks/reserv/reserv.hook';
//styles
import styles from 'src/asset/scss/styles/userMemberInfo.module.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import SubtitleArea from 'src/webapp/views/wrapper/SubtitleArea';//서브타이틀공통컴포넌트
//comp
import List from './reservList/List';//예약리스트데이터
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인

export default function ReservList() {
    const {pageRef//무한로딩페이지DOM
        // , searchRef//검색어DOM
        // , scrollRef//elementScroll관리Ref
        , memberReservList//예약리스트데이터
        , memberReservListAPI//예약리스트API
    } = useReservHook();
    //useEffect
    useEffect(() => {
        memberReservListAPI(0, 1);//회원예약내역리스트API
    }, []);
    //infinityObserver
    const [ inViewRef, inView ] = useInView({ threshold: .5 });
    useEffect(() => {
        if (inView && (pageRef.current != null)) { memberReservListAPI(1, 1); }//알림리스트API
    }, [inView]);

    return ( 
        <Element tag={`div`} className={styles.reservContainer}>
            <Element tag={`div`} className={styles.titleArea}>
                <SubtitleArea title={'이용 내역'} cnt={`${memberReservList[0]?.TOT_CNT ?? 0}건`}></SubtitleArea>
                </Element>
            <List memberReservListAPI={memberReservListAPI} ref={pageRef} list={memberReservList} />
            {memberReservList?.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
            : memberReservList?.length > 0 && pageRef.current === null ? <InViewData readAll={true} /> 
            : null}
        </Element>
    );
}